export default __webpack_public_path__ + "media/images/features/ambassador/profiles/jun_san-31943a48e6b5b946706fdf9c8ef46e8b.jpg";